import { useGetUserQuery } from '../../modules/user/api/user-api';
import { UserPermissionType } from '../../modules/user/models/user-permission-type';
import { hasPermission } from '../utils/has-permission';

export const useHasPermission = (permissionType: UserPermissionType): boolean => {
  const { data: currentUser } = useGetUserQuery();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return hasPermission(currentUser!, permissionType);
};
